// ------------------------------------------------------------------------------------
// 指導員サイト 教習生編集画面の「データ取得」ボタン処理
// Obicから対象の教習生データを取得する
//

const buildRequest = (coreSystemNumber) => {
  const xmlHR = new XMLHttpRequest();
  const token = document.getElementsByName('csrf-token')[0].content;
  const regexp = new RegExp('/([^/]*)/*');
  const schoolName = regexp.exec(location.pathname)[1];
  const url = `${location.protocol}//${window.location.host}/api/core_system/obic/v1/${schoolName}/student/${coreSystemNumber}`;
  xmlHR.open('GET', url, true);
  xmlHR.setRequestHeader('X-CSRF-Token', token);

  return xmlHR;
};

const showAlert = (message = '') => {
  alert(`教習生情報の取得に失敗しました。${message}`);
};

const getFields = () => {
  const coreSystemNumberField = document.getElementById('student_core_system_number');
  const familyNameField = document.getElementById('student_family_name');
  const familyNameKanaField = document.getElementById('student_family_name_kana');
  const givenNameField = document.getElementById('student_given_name');
  const givenNameKanaField = document.getElementById('student_given_name_kana');
  const emailField = document.getElementById('student_email');
  const entranceDateField = document.getElementById('student_entrance_date');
  const statusField = document.getElementById('student_status');

  return {
    coreSystemNumberField,
    familyNameField,
    familyNameKanaField,
    givenNameField,
    givenNameKanaField,
    emailField,
    entranceDateField,
    statusField,
  };
};

const setStudentFieldValues = (values) => {
  // core_system_numberは同期しないようになったので注意
  const {
    familyNameField,
    familyNameKanaField,
    givenNameField,
    givenNameKanaField,
    emailField,
    entranceDateField,
    statusField,
  } = getFields();

  familyNameField.value = values.family_name;
  familyNameKanaField.value = values.family_name_kana;
  givenNameField.value = values.given_name;
  givenNameKanaField.value = values.given_name_kana;
  if (values.email) {
    emailField.value = values.email;
  }
  entranceDateField.value = values.entrance_date;
  statusField.value = values.status;
};

const changeTargetElementDisabledStatus = (target, isDisable) => {
  if (target === null) return;

  if (isDisable) {
    target.setAttribute('disabled', true);
  } else {
    target.removeAttribute('disabled');
  }
};

// メール送信ボタンのdisabledを解除するために自動入力された値を取得してメアドか電話番号があれば解除
const removeDisabledFromSubmitWithEmailBtn = (phone, email, submitWithEmailBtn) => {
  if (phone) {
    const contactValue = email.value || phone.value;
    changeTargetElementDisabledStatus(submitWithEmailBtn, !contactValue);
  } else {
    changeTargetElementDisabledStatus(submitWithEmailBtn, !email.value);
  }
};

const clearCompleteLessonSlots = () => {
  document.querySelectorAll('.completed-lesson-slot-checkbox:checked').forEach((e) => e.click());
};

const setCompleteLessonSlots = (values) => {
  clearCompleteLessonSlots();

  const lesson_slots_first = Array.from(document.getElementsByClassName('lesson-slot-first'));
  const lesson_slots_second = Array.from(document.getElementsByClassName('lesson-slot-second'));

  lesson_slots_first.forEach((lesson_slot) => {
    if (values.lesson_slot_codes.includes(lesson_slot.id)) lesson_slot.click();
  });

  const provisionalLicenseCheckBox = document.getElementById('provisional_license');
  if (values.provisional_license) provisionalLicenseCheckBox.click();

  lesson_slots_second.forEach((lesson_slot) => {
    if (values.lesson_slot_codes.includes(lesson_slot.id)) lesson_slot.click();
  });
};

export default () => {
  const form = document.getElementById('student-form');
  const button = document.getElementById('get-core-system-students');
  const email = document.getElementById('student_email');
  const phone = document.getElementById('student_phone'); // SMSオプションでnullかもしれない
  const submitWithEmailBtn = document.getElementById('send-email-btn');

  if (!form || !button) return;

  const coreSystem = button.dataset?.coreSystem;
  if (coreSystem !== 'obic_api') return;

  button.addEventListener('click', () => {
    button.classList.add('disabled');
    const {
      coreSystemNumberField,
      familyNameField,
      familyNameKanaField,
      givenNameField,
      givenNameKanaField,
      emailField,
      statusField,
    } = getFields();

    const coreSystemNumber = coreSystemNumberField.value;

    // 教習生番号未入力の場合
    if (!coreSystemNumber) return;

    // 既に入力された項目がある場合
    const completedLessonSlotsSelector = '.completed-lesson-slot-checkbox';
    const completedLessonSlots = document.querySelectorAll(
      `${completedLessonSlotsSelector}:checked`,
    );
    const holdingLicenseTypesSelector = '.holding-license-type-ids';
    const holdingLicenseTypes = document.querySelectorAll(`${holdingLicenseTypesSelector}:checked`);

    const isFilled =
      familyNameField.value ||
      familyNameKanaField.value ||
      givenNameField.value ||
      givenNameKanaField.value ||
      emailField.value ||
      statusField.value !== 'before_entry' ||
      completedLessonSlots.length > 0 ||
      holdingLicenseTypes.length > 0;

    if (isFilled && !confirm('既に入力された項目が存在します。上書きしてもよろしいですか？')) {
      return;
    }

    const request = buildRequest(coreSystemNumber);
    request.onerror = showAlert;
    request.onload = () => {
      button.classList.remove('disabled');
      if (request.status !== 200) {
        let errorMessage = '';
        try {
          errorMessage = `(${JSON.parse(request.responseText).obic})`;
        } catch {}
        showAlert(errorMessage);

        return;
      }

      const response = JSON.parse(request.responseText);
      setStudentFieldValues(response.student);

      if (document.querySelectorAll(completedLessonSlotsSelector).length > 0)
        setCompleteLessonSlots(response.attendances);

      removeDisabledFromSubmitWithEmailBtn(phone, email, submitWithEmailBtn);
    };
    request.send();
  });
};
